import { addClass, addStyle, removeClass, removeStyle } from 'app/utils/domHelpers';

function imageDynamicsConstructor({ scales }) {
  let currentScale;
  let scaleChange;

  let offset;
  let containerDOMElement;
  let imageDOMElement;

  let height;
  let width;
  let top;
  let left;

  const computeScaleChange = scaleFactor => currentScale * (scaleFactor - 1);

  const offsetFromScaling = focusPoint => ({
    x: (left - focusPoint.x) * scaleChange,
    y: (top - focusPoint.y) * scaleChange,
  });

  const minValidOffset = dimension => dimension * (1 - currentScale);

  const between = (min, max, value) => Math.min(max, Math.max(min, value));

  const combineOffsets = (a, b) => ({
    x: between(minValidOffset(width), 0, a.x + b.x),
    y: between(minValidOffset(height), 0, a.y + b.y),
  });

  const transformImage = (imageOffset, scale) => {
    addStyle('transform', `translate(${imageOffset.x}px, ${imageOffset.y}px) scale(${scale})`, imageDOMElement);
  };

  const setInitialValues = () => {
    currentScale = scales.min;
    offset = { x: 0, y: 0 };
    scaleChange = 0;
  };

  const updateProps = containerRef => {
    containerDOMElement = containerRef.current;
    imageDOMElement = containerDOMElement.querySelector('.image-zoomer__image');
    ({ height, width, top, left } = containerDOMElement.getBoundingClientRect());
  };

  const discreteZoomIn = focusPoint => {
    ({ height, width, top, left } = containerDOMElement.getBoundingClientRect());
    scaleChange = computeScaleChange(scales.fixedZoom);
    currentScale = scales.fixedZoom;
    offset = offsetFromScaling(focusPoint);
    transformImage(offset, currentScale);
    addClass('image-zoomer__image--zoomed', imageDOMElement);
  };

  const continuousZoom = (pinchZoomFactor, focusPoint) => {
    scaleChange = between(scales.min - currentScale, scales.max - currentScale, computeScaleChange(pinchZoomFactor));
    currentScale = between(scales.min, scales.max, currentScale + scaleChange);
    offset = combineOffsets(offset, offsetFromScaling(focusPoint));
    transformImage(offset, currentScale);
  };

  const move = focusPoint => {
    transformImage(offsetFromScaling(focusPoint), currentScale);
  };

  const dragMove = translation => {
    offset = combineOffsets(offset, translation);
    transformImage(offset, currentScale);
  };

  const resetZoom = () => {
    setInitialValues();
    removeStyle('transform', imageDOMElement);
    removeClass('image-zoomer__image--zoomed', imageDOMElement);
  };

  const isZoomed = () => currentScale > scales.min;

  setInitialValues();

  return {
    updateProps,
    discreteZoomIn,
    resetZoom,
    move,
    dragMove,
    continuousZoom,
    isZoomed,
  };
}

export default imageDynamicsConstructor;
